"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _default = require("./default");
Object.keys(_default).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _default[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _default[key];
    }
  });
});
var _empty = require("./empty");
Object.keys(_empty).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _empty[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _empty[key];
    }
  });
});
var _errorPage = require("./error-page");
Object.keys(_errorPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _errorPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _errorPage[key];
    }
  });
});
var _myPages = require("./my-pages");
Object.keys(_myPages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _myPages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _myPages[key];
    }
  });
});
var _onlyHeader = require("./only-header");
Object.keys(_onlyHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _onlyHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _onlyHeader[key];
    }
  });
});
